import React from "react";
import { Box, Button, Stack } from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";

export default function StartActions({
	onStartChat,
	onStartCall,
	showCall,
	showChat = true,
	variant = "solid",
	startChatLabel = "Start a new chat",
	startCallLabel = "Start a new call",
}) {
	const buttonSx = variant === "glass"
		? {
			height: 44,
			borderRadius: "999px",
			textTransform: "none",
			fontSize: "14px",
			fontWeight: 500,
			color: "black",
			gap: 1.5,
			border: "1px solid rgba(0, 0, 0, 0.7)",
			background: "rgba(255,255,255,0.24)",
			backdropFilter: "blur(2px) saturate(180%)",
			WebkitBackdropFilter: "blur(2px) saturate(180%)",
			"&.MuiButton-root:hover": {
				background: "rgba(255,255,255,0.6)",
				border: "1px solid rgba(0, 0, 0, 0.8)",
			},
		}
		: {
			height: 44,
			borderRadius: "999px",
			textTransform: "none",
			fontSize: "14px",
			fontWeight: 500,
			gap: 1.5,
			color: "black",
			border: "1px solid rgba(0, 0, 0, 0.7)",
			background: "white",
			"&.MuiButton-root:hover": {
				background: "rgba(189, 187, 187, 0.14)",
				border: "1px solid rgba(0, 0, 0, 0.7)",
			},
		};

	return (
		<Box sx={{ width: "100%" }}>
			<Stack spacing={1.5}>
				{showChat && (
					<Button
						fullWidth
						variant="outlined"
						startIcon={<ChatBubbleOutlineIcon />}
						onClick={onStartChat}
						sx={{
							...buttonSx,
							"& .MuiButton-startIcon": { color: "inherit", m: 0 },
						}}
					>
						{startChatLabel}
					</Button>
				)}
				{showCall && (
					<Button
						fullWidth
						variant="outlined"
						startIcon={<PhoneOutlinedIcon />}
						onClick={onStartCall}
						sx={{
							...buttonSx,
							"& .MuiButton-startIcon": { color: "inherit", m: 0 },
						}}
					>
						{startCallLabel}
					</Button>
				)}
			</Stack>
		</Box>
	);
}
